import React, {useRef, useState} from 'react';
import useIntersectionObserver from "../hooks/useIntersectionObserver";

function Header(props) {

    const [isOpen, setOpenState] = useState(undefined);
    let headerNavClass = 'header-nav ' + isOpen;
    const headerRef = useRef();
    const onScreen = useIntersectionObserver(headerRef, { threshold: 0.5 });

    function handleOpen(e) {
        setOpenState((prevOpenState) => {
            let newOpenState = prevOpenState;
            if (prevOpenState === undefined) {
                newOpenState = 'opened';
            } else {
                newOpenState = undefined;
            }
            return newOpenState;
        });
    }

    return (
        <header className={'header header-' + onScreen} ref={headerRef}>
            <div className="header-container">
                <div className="header-logo">
                    News
                </div>
                <nav className={headerNavClass}>
                    <ul className="header-menu">
                        <li><a href="#" className="header-link">News</a></li>
                    </ul>
                </nav>
                <div className="header-icon" onClick={handleOpen}>
                    <span></span>
                </div>
            </div>
        </header>
    );
}

export default Header;